export default {
  sending: 'sending',
  sended: 'sended',
  received: 'received',
  read: 'read',
  error: 'error'
}
